import React, { useEffect, useState } from "react";
import Background from '../../images/tickers.png';
import Path from '../../images/path.png';
import { Box, Container } from "@mui/system";
import { Skeleton, Typography } from "@mui/material";
import { useVisible } from "react-hooks-visible";
import CountUp from "react-countup";
import theme from "../../theme/theme";

const Tickers = ({ figures, loading}) => {

    const [ref, visible] = useVisible((vi) => vi > 0.5);
    const [count, setCount]=useState(false);
    useEffect(() => {
        if (visible && !count){
            setCount(true);
        }
    }, [visible]);

    return (
        <>
            { loading ?
                <Skeleton
                    variant="rectangular"
                    sx={{
                        height: "297px",
                        width: "100%",
                    }}
                />
            : figures ?
                <Box
                    id="tickers-box"
                    sx={{
                        backgroundImage: `url(${Background}), url(${Path})`,
                        backgroundBlendMode: "multiply",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center top",
                        paddingTop: {
                            xs: "80px",
                            md: "200px",
                            lg: "13%",
                            xl: "13%",
                        },
                        paddingBottom: {
                            xs: "40px",
                            md: "120px",
                        },
                        marginTop: {
                            xs: "-200px",
                            md: "-200px",
                            lg: "-13%",
                            xl: "-13%",
                        },
                        position: "relative",
                        backgroundPosition: {
                            xs: "left top",
                            md: "center top",
                        },
                    }}
                    ref={ref}
                >
                    <Container maxWidth='xl'>
                        <h4
                            style={{
                                color: "#ffffff",
                                textAlign: "center",
                                fontSize: "2rem",
                                fontWeight: "600",
                            }}
                        >
                            Experts in safety risk management and ESG for commercial real estate
                        </h4>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                flexWrap: {
                                    xs: "wrap",
                                    md: "nowrap",
                                },
                            }}
                        >
                            {figures.map((tickers, index) => {
                                const countDuration= tickers.count_seconds;
                                const countFrom = 0;
                                const countTo = tickers.count_to;
                                const decimals = tickers.decimals;

                                return(
                                    <Box
                                        key={index}
                                        sx={{
                                            textAlign: "center",
                                            width: {
                                                xs:'50%',
                                                md:'25%',
                                            },
                                            p:'1rem'
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#ffffff",
                                                fontSize:{
                                                    xs:'1.8rem',
                                                    md:'2.5rem'
                                                },
                                                lineHeight: "2.5rem",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {tickers.prepend}
                                            {count?
                                                <CountUp
                                                    end={countTo}
                                                    duration={countDuration}
                                                    start={countFrom}
                                                    decimals={decimals}
                                                />
                                            :
                                                0
                                            }
                                            {tickers.append}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#B2DAE3",
                                                fontSize:{
                                                    xs:'0.9rem',
                                                    md:'1.1rem'
                                                },
                                                fontWeight:600,
                                                m:'0.5rem auto 0 auto',
                                                lineHeight:'1.4rem',
                                                maxWidth:'200px'
                                            }}
                                        >
                                            {tickers.label}
                                        </Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Container>
                </Box>
            : null }
        </>
    );
};

export default Tickers;
